import React, { useState } from "react";

export interface MultiSelectOption {
  id: string;
  label: string;
}

export interface MultiSelectProps {
  options: MultiSelectOption[];
  selected: Set<string>;
  onToggle: (id: string) => void;
  allLabel: string;
}

/* Compact multi-select dropdown — selected count in the trigger, list with
   checkboxes in the dropdown. Used by the simulation setup form to choose
   which matters from a bundle are in scope. */
export function MultiSelect({ options, selected, onToggle, allLabel }: MultiSelectProps): JSX.Element {
  const [open, setOpen] = useState<boolean>(false);
  const label =
    selected.size === 0
      ? "None selected"
      : selected.size >= options.length
        ? allLabel
        : selected.size + " selected";
  return (
    <div style={{ position: "relative" }}>
      <button
        className="sel"
        style={{ width: "100%", textAlign: "left", cursor: "pointer" }}
        onClick={() => setOpen((o) => !o)}
      >
        {label}
      </button>
      {open && (
        <>
          <div className="backdrop" onClick={() => setOpen(false)} />
          <div className="msdrop">
            {options.map((o) => (
              <button key={o.id} className="msitem" onClick={() => onToggle(o.id)}>
                <input
                  type="checkbox"
                  className="chk"
                  readOnly
                  checked={selected.has(o.id)}
                  style={{ width: 16, height: 16 }}
                />
                <span>{o.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
